<template>
  <div>
    <v-app-bar app absolute color="white" elevation="1" tabs>
      <v-spacer></v-spacer>

      <v-toolbar-title class="ma-0">
        <h1 class="headline font-weight-bold pt-2">
          {{ t.app.misericordia }}
          <span class="primary--text">{{ t.app.diadia }}</span>
        </h1>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- tabs -->
      <div class="d-flex w100" slot="extension">
        <div class="mr-auto">
          <v-tabs slider-color="primary" v-model="tab">
            <v-tab :key="0" :ripple="false">
              <v-icon :color="tab === 0 ? 'primary' : 'grey'">
                local_library
              </v-icon>
            </v-tab>

            <v-tab :key="1" :ripple="false">
              <v-icon :color="tab === 1 ? 'primary' : 'grey'">
                playlist_add_check
              </v-icon>
            </v-tab>
          </v-tabs>
        </div>

        <!-- menu -->

        <v-menu v-model="homeMenu" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" :ripple="false">
              <v-icon color="grey lighten-1">more_vert</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-list>
              <v-list-item to="/user">
                <v-list-item-avatar>
                  <v-icon>face</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ t.config.opcionesUsuario }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon>tune</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                v-show="showInstall || !browserPwaCompatible"
                :disabled="pwaInstalled"
                @click="instalar()"
              >
                <v-list-item-avatar>
                  <v-icon>add_to_home_screen</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ t.app.instalar }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon
                    v-text="pwaInstalled ? 'done_all' : 'help_outline'"
                  ></v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </v-app-bar>

    <v-content>
      <v-container class="ma-0 pa-0" fluid>
        <v-tabs-items v-model="tab">
          <v-tab-item :key="0">
            <mdd-portada-libro :infoo-hoy="infooHoy"></mdd-portada-libro>
          </v-tab-item>

          <v-tab-item :key="1">
            <mdd-portada-cuaderno :infoo-hoy="infooHoy"></mdd-portada-cuaderno>
          </v-tab-item>
        </v-tabs-items>

        <!-- boton  -->
        <!-- <v-fab-transition> -->
        <v-fade-transition hide-on-leave>
          <v-btn
            :color="activeFab.color"
            v-show="activeFab.show"
            fixed
            fab
            dark
            bottom
            right
            @click.stop="showBottomMenu"
          >
            <v-icon>{{ activeFab.icon }}</v-icon>
          </v-btn>
        </v-fade-transition>
        <!-- </v-fab-transition> -->
      </v-container>
    </v-content>

    <!-- menu mdd -->
    <v-bottom-sheet v-model="menuMdd" :inset="inset">
      <v-list>
        <!-- oracion dia -->
        <v-list-item @click.stop="goReflex('dia')">
          <v-list-item-avatar>
            <v-icon color="orange">wb_sunny</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ t.mdd.oracionManiana }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>{{ iconPrayDay }}</v-icon>
          </v-list-item-action>
        </v-list-item>
        <!-- oracion noche -->
        <v-list-item @click.stop="goReflex('noche')">
          <v-list-item-avatar>
            <v-icon color="cyan darken-1">nights_stay</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ t.mdd.oracionNoche }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>{{ iconPrayNight }}</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-divider></v-divider>
        <!-- lecturas biblicas -->
        <v-list-item @click.stop="goLecturas()">
          <v-list-item-avatar>
            <v-icon color="cyan">menu_book</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ t.mdd.lecturasDia }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>today</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>

    <!-- menu cuaderno -->
    <v-bottom-sheet v-model="menuCuaderno" :inset="inset">
      <v-list>
        <!-- oracion dia -->
        <v-list-item @click.stop="goCuadernoMes">
          <v-list-item-avatar>
            <v-icon :color="colorName + ' lighten-2'">book</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              Mi cuaderno de oracion
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>
  </div>
</template>

<script>
// import { VFabTransition } from "vuetify/lib/components/transitions";
import { VFadeTransition } from "vuetify/lib/components/transitions";

import mixAppConfig from "../mixs/mixAppConfig.js";
import mixUserConfig from "../mixs/mixUserConfig.js";
import mixUserColor from "../mixs/mixUserColor.js";
import MddPortadaLibro from "./portadas/MddPortadaLibro.vue";
import MddPortadaCuaderno from "./portadas/MddPortadaCuaderno.vue";

export default {
  name: "mdd-inicio",
  components: { MddPortadaLibro, MddPortadaCuaderno, VFadeTransition },
  mixins: [mixAppConfig, mixUserConfig, mixUserColor],
  props: ["infooHoy"],
  mounted() {
    if ("onappinstalled" in window) {
      window.addEventListener("appinstalled", function() {
        this.pwaInstalled = true;
        this.showInstall = false;
      });
    }
    // https://pwaexperts.io/tutoriales/como-agregar-pwa-home-screen-movil-escritorio-chrome
    if ("onbeforeinstallprompt" in window) {
      window.onload = () => {
        window.addEventListener("beforeinstallprompt", e => {
          e.preventDefault();

          this.showInstall = true;
          this.installPrompt = e;
        });
      };
    }
  },
  data() {
    return {
      installPrompt: null,
      pwaInstalled: false,
      hght: "100%",
      homeMenu: false,
      search: false,
      menuMdd: false,
      menuCuaderno: false,
      showInstall: false,
      tab: 0
    };
  },
  computed: {
    appBreakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    activeFab() {
      const fabs = [
        { show: true, color: "primary", icon: "local_library" },
        // eslint-disable-next-line prettier/prettier
        { show: false, color: this.colorName + " lighten-2", icon: "playlist_add_check" }
      ];
      return fabs[this.tab];
    },
    browserPwaCompatible() {
      return "onbeforeinstallprompt" in window;
    },
    hoy() {
      return {
        anio: this.infooHoy.anio,
        mes: this.infooHoy.mes,
        dia: this.infooHoy.dia,
        nombreDia: this.t.dias[this.infooHoy.diaSem],
        nombreMes: this.t.meses[this.infooHoy.mes]
      };
    },
    iconPrayDay() {
      if (this.userNoteToday.cd === 0) return "access_time";
      return this.userNoteToday.cd >= 9 ? "done_all" : "done";
    },
    iconPrayNight() {
      return this.userNoteToday.cn >= 1 ? "done_all" : "access_time";
    },
    inset() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    showDialog() {
      return this.$route.meta.showDialog || false;
    },
    showFull() {
      return this.$vuetify.breakpoint.smAndDown || this.$route.meta.showFull;
    },
    userAuth() {
      return this.$store.getters["user/auth"];
    },
    userNoteToday() {
      return this.$store.getters["user/notes/item"](this.infooHoy.iso);
    }
  },
  methods: {
    instalar() {
      // https://levelup.gitconnected.com/vue-pwa-example-298a8ea953c9
      let installPrompt = this.installPrompt;

      if (this.browserPwaCompatible && installPrompt) {
        installPrompt.prompt();

        installPrompt.userChoice.then(result => {
          if (result.outcome === "accepted") {
            // Cambiar el icono de la app
            installPrompt = null;
          }
        });
      } else {
        this.$router.push({ name: "instalar" });
      }
    },
    goReflex(filter) {
      this.menuMdd = false;
      let params = {
        filter: filter,
        anio: this.hoy.anio,
        mes: this.hoy.mes,
        dia: this.hoy.dia,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };
      this.$router.push({ name: "MddPaginaDia", params: params }).catch(e => {
        this.$store.dispatch("app/saveErrorReport", {
          e: e,
          line: 179,
          src: "mdd-portada-libro"
        });
      });
    },
    goLecturas() {
      this.menuMdd = false;
      let params = {
        anio: this.hoy.anio,
        mes: this.hoy.mes,
        dia: this.hoy.dia,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };

      this.$router
        .push({ name: "MddLecturasBiblicas", params: params })
        .catch(e => {
          this.$store.dispatch("app/saveErrorReport", {
            e: e,
            line: 197,
            src: "mdd-portada-libro"
          });
        });
    },
    goCuadernoMes() {
      this.menuMdd = false;
      let params = {
        anio: this.hoy.anio,
        mes: this.hoy.mes,
        dia: this.hoy.dia,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };

      this.$router.push({ name: "MddCuadernoMes", params: params }).catch(e => {
        this.$store.dispatch("app/saveErrorReport", {
          e: e,
          line: 197,
          src: "mdd-portada-libro"
        });
      });
    },
    showBottomMenu() {
      switch (this.tab) {
        case 0:
          this.menuMdd = !this.menuMdd;
          break;
        case 1:
          this.menuCuaderno = !this.menuCuaderno;
      }
    }
  }
};
</script>

<style>
.w100 {
  width: 100% !important;
}

.h100 {
  height: 100% !important;
}
</style>
